// Module
var code = `<div class="flex-horizontal">
    <div data-bind="with: alert">
        <div class="dropdown" data-bind="visible: canBePostponed">
            <button class="btn dropdown-toggle" data-toggle="dropdown" data-bind="enable: !_.includes(\$parent.spinners.postpone(), id), css: { 'btn-spinner': _.includes(\$parent.spinners.postpone(), id) }">
                <i class="icon-clock"></i> <span>Postpone</span>
                <span class="caret"></span>
            </button>
            <ul class="dropdown-menu" data-bind="foreach: \$root.postponeOptions">
                <li><a href="#" data-bind="text: label, click: _.partial(\$root.postpone, value)"></a></li>
            </ul>
        </div>
    </div>
    <div class="flex-separator"></div>
    <div>
        <button type="button" class="btn btn-default" data-bind="click: close" title="Close this dialog">
            <i class="icon-cancel"></i><span>Close</span>
        </button>
        <button type="button" class="btn btn-primary" data-bind="click: dismiss" title="Dismiss this alert">
            <i class="icon-dismiss-all"></i><span>Dismiss alert</span>
        </button>
    </div>
</div>
`;
// Exports
export default code;